import { gql } from '@apollo/client'

export const CHART3_QUERY = gql`
  query processingsClosedCountByProcessingTypes(
    $filter: ProcessingsClosedCountByProcessingTypesFilter
    $groupBy: ProcessingsClosedCountByProcessingTypesGroupBy
  ) {
    processingsClosedCountByProcessingTypes(filter: $filter, groupBy: $groupBy) {
      series {
        color
        title
        usersAverage
        processingTypeAverage
        serie {
          name
          date
          count
        }
      }
    }
  }
`
